export default {
	getPersonFullName (person) {
		let fullName = person.firstName ? ' ' + person.firstName : '';
		fullName += person.lastName ? ' ' + person.lastName : '';
		fullName += person.secondLastName ? ' ' + person.secondLastName : '';
		return fullName;
	},
	getPersonInitials (person) {
		let initials = person.firstName ? person.firstName.charAt(0) : '';
		initials += person.lastName ? person.lastName.charAt(0) : '';
		initials += person.secondLastName ? person.secondLastName.charAt(0) : '';
		return initials.toUpperCase();
	}
};



// WEBPACK FOOTER //
// ./src/helpers/persons.js